import dayjs from 'dayjs'
import { RefObject, useEffect } from 'react'

// Сколько пункт меню считается новым после даты появления
export const NAVIGATION_NEW_PERIOD_MONTHS = 1

// Пункт с newSince: 'YYYY-MM-DD' помечен «Новое» до той же даты следующего месяца, потом пометка пропадает сама.
// Пустая или кривая дата — пункт не новый
export const isNewNavigationItem = (newSince?: string, now: Date = new Date()): boolean => {
    if (!newSince) return false

    const since = dayjs(newSince)
    if (!since.isValid()) return false

    return dayjs(now).isBefore(since.add(NAVIGATION_NEW_PERIOD_MONTHS, 'month'))
}

// Отступ меню от верха и низа экрана (как top у .navigation в navigation.less)
export const NAVIGATION_STICKY_GAP = 30

// Меню выше экрана листается вместе со страницей, а показав низ (или верх) — встаёт и дальше не уезжает.
// Сдвигаем top липкого меню на величину прокрутки в пределах от «виден низ» до «виден верх».
// Меню помещается в экран — top постоянный, как в CSS
export const useStickyNavigation = (ref: RefObject<HTMLElement>, enabled: boolean) => {
    useEffect(() => {
        const el = ref.current
        if (!enabled || !el) return

        let top = NAVIGATION_STICKY_GAP
        let lastScroll = window.scrollY

        const update = () => {
            const minTop = Math.min(NAVIGATION_STICKY_GAP, window.innerHeight - el.offsetHeight - NAVIGATION_STICKY_GAP)

            top = Math.min(NAVIGATION_STICKY_GAP, Math.max(minTop, top - (window.scrollY - lastScroll)))
            lastScroll = window.scrollY
            el.style.top = `${top}px`
        }

        const resize = new ResizeObserver(update)
        resize.observe(el)
        window.addEventListener('scroll', update, { passive: true })
        window.addEventListener('resize', update)

        return () => {
            resize.disconnect()
            window.removeEventListener('scroll', update)
            window.removeEventListener('resize', update)
        }
    }, [ref, enabled])
}
